<template>
    <div class="dropdown">
        <a href="#" class="badge badge-light dropdown-toggle" @click.prevent="toggle" ref="triggerRef" :class="{ 'disabled': disabled }">
            {{ modelValue?.[optionValue] || $t('labels.empty') }}
        </a>

        <Teleport to="body">
            <div 
                v-if="isOpen"
                class="dropdown-menu show"
                ref="menuRef"
                style="display: block;"
            >
                <a 
                    href="#"
                    class="dropdown-item"
                    v-for="option in options"
                    :key="option.value"
                    @click.prevent="select(option)"
                >
                    {{ option?.[optionValue] || $t('labels.empty') }}
                </a>
            </div>
        </Teleport>
    </div>
</template>
<script>
import { createPopper } from '@popperjs/core';

export default {
    name: "AppDropdown",
    props: {
        modelValue: {
            type: Object,
            default: () => ({})
        },
        options: {
            type: Array,
            default: () => []
        },
        optionValue: {
            type: String,
            default: 'name'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            isOpen: false,
            popperInstance: null
        }
    },
    methods: {
        toggle() {
            if (this.disabled) {
                return;
            }
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        },
        open() {
            this.isOpen = true;
            this.$nextTick(() => {
                this.createPopper();
                document.addEventListener('click', this.handleClickOutside);
            });
        },
        close() {
            this.isOpen = false;
            if (this.popperInstance) {
                this.popperInstance.destroy();
                this.popperInstance = null;
            }
            document.removeEventListener('click', this.handleClickOutside);
        },
        select(option) {
            this.$emit('update:modelValue', option);
            this.close();
        },
        createPopper() {
            if (this.$refs.triggerRef && this.$refs.menuRef) {
                this.popperInstance = createPopper(this.$refs.triggerRef, this.$refs.menuRef, {
                    placement: 'bottom-start',
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 5],
                            },
                        },
                    ],
                });
            }
        },
        handleClickOutside(event) {
            const menuElement = this.$refs.menuRef;
            const triggerElement = this.$refs.triggerRef;

            if (menuElement && triggerElement) {
                if (!menuElement.contains(event.target) && !triggerElement.contains(event.target)) {
                    this.close();
                }
            }
        }
    },
    beforeUnmount() {
        this.close();
    }
}
</script>